export default [
    {
        path: '/express-pick/user',
        name: 'express_pick_user',
        component: () => import('@src/express-pick/express-pick-user.vue'),
        meta: {
            title: 'Express Picker',
            role: 'ROLE_EXPRESS_PICK_USER',
        },
    },
];
